//React
import React from 'react';


//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

//Add
import TextareaAutosize from 'react-textarea-autosize';
import { UAParser } from 'ua-parser-js';
//Icon
import CloseIcon from '@material-ui/icons/Close';
//Part
import PartCheckbox from './PartCheckbox';

//JSON
var profileTemplate = require('../data/profileTemplate.json');

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

      dialogOpen: false,
      visibleIndex: 0,
      templateItem: profileTemplate.template,
      answerLike: '',
      answerPersonality: '',
      answerHoliday: '',
      answerSame: '',
  	}
  }


  _renderQuestion(value, index, arr) {
    return (
      <div
        key={index}
        style={{
          display: (this.state.visibleIndex === index ? '' : 'none'),
        }}
      >
        <div>
          <h3>{value.question}</h3>
        </div>
        <div>
          <TextareaAutosize
            className="input_blue round6"
            style={{fontSize:"1.2em", width:'100%'}}
            value={ this.state['answer' + value.id] }
            onChange={ (event) => this.setState({ ['answer' + value.id]: event.target.value}) }
            placeholder=""
            maxRows={5}
          >
            {this.state['answer' + value.id]}
          </TextareaAutosize>
        </div>
      </div>
    );
  }

  _renderAnswer(value, index, arr) {
    return (
      <div
        key={index}
        style={{
          display: (this.state.visibleIndex === index ? '' : 'none'),
        }}
      >
        <div>
          {
            value.answerSample.map((answerSampleValue, answerSampleIndex) =>
              this._renderAnswerSample(answerSampleValue, answerSampleIndex, value.id, value.answerCount)
            )
          }
        </div>

      </div>
    );
  }

  _renderButton(value, index, arr) {
    return (
      <div
        key={index}
        style={{
          display: (this.state.visibleIndex === index ? '' : 'none'),
        }}
      >
        <div>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >
            {
              (index > 0) ? (
                <Button
                  variant="outlined"
                  color='primary'
                  size='small'
                  style={{width: '100px', fontSize:'1.2em'}}
                  onClick={ () => this.setState({visibleIndex: (this.state.visibleIndex - 1) }) }
                >
                  戻る
                </Button>
              ) : (
                <div></div>
              )
            }
            {
              (index < 3) ? (
                <Button
                  variant="contained"
                  color='primary'
                  size='small'
                  style={{width: '100px', fontSize:'1.2em'}}
                  onClick={ () => this.setState({visibleIndex: (this.state.visibleIndex + 1) }) }
                >
                  次へ
                </Button>
              ) :(
                <Button
                  variant="contained"
                  color='primary'
                  onClick={ () => this._createSubmit() }
                  style={{width: '120px', fontSize:'1.2em'}}
                >
                  作成する
                </Button>
              )
            }
          </div>
        </div>
      </div>
    );
  }

  _renderAnswerSample(answerSampleValue, answerSampleIndex, id, answerCount) {

    if (answerCount === 'multi') {
      return (
        <PartCheckbox
          key={answerSampleIndex}
          value={answerSampleValue}
          checked={(this.state['answer' + id].indexOf(answerSampleValue) > -1)}
          click={ (value) => this._answerSampleMultiClick(id, answerSampleValue) }
          style={{margin:"3px"}}
        >
          {answerSampleValue}
        </PartCheckbox>
      );
    }
    else if (answerCount === 'single') {
      return (
        <PartCheckbox
          key={answerSampleIndex}
          value={answerSampleValue}
          checked={(this.state['answer' + id].indexOf(answerSampleValue) > -1)}
          click={ (value) => this._answerSampleSingleClick(id, answerSampleValue) }
          style={{margin:"3px"}}
        >
          {answerSampleValue}
        </PartCheckbox>
      );
    }
  }

  _answerSampleMultiClick(id, value) {
    let state = this.state['answer' + id];
    let regexp = new RegExp(',? ?' + value, 'g');
    if ((state.indexOf(value) > -1)) {
      state = state.replace(regexp, '');
    }
    else {
      if (state.length !== 0) {
        state = state + ', ';
      }
      state = state + value;
    }
    this.setState({ ['answer' + id]: state});
  }

  _answerSampleSingleClick(id, value) {
    let state = this.state['answer' + id];
    state = value;
    this.setState({ ['answer' + id]: state});
  }

  _createSubmit() {
    let comment = '閲覧ありがとうございます。';
    if (this.state.answerLike.length > 0) {
      comment = comment + '\n\n魅かれるタイプは\n' + this.state.answerLike;
    }
    if (this.state.answerPersonality.length > 0) {
      comment = comment + '\n\n性格は\n' + this.state.answerPersonality;
    }
    if (this.state.answerHoliday.length > 0) {
      comment = comment + '\n\n休日の過ごし方は\n' + this.state.answerHoliday;
    }
    if (this.state.answerSame.length > 0) {
      comment = comment + '\n\n似ていると言われたことのある有名人は \n' + this.state.answerSame;
    }
    this.props.submit(comment);
    this.props.close();
  }

	render() {
    let ua = UAParser();
		return (
			<Dialog
        open={this.props.open}
        maxWidth='xs'
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            簡単プロフ作成
          </div>
          <div>
            <IconButton onClick={ () => this.props.close() }>
              <CloseIcon />
            </IconButton>
          </div>

        </div>
        <div style={{margin:'10px'}}>
          {
            this.state.templateItem.map((value, index, arr) =>
              this._renderQuestion(value, index, arr)
            )
          }
        </div>

        {
          (ua.device.type === 'mobile' || ua.device.type ===  'tablet') && (
            <DialogContent style={{margin:'10px', padding:'0px'}}>
              {
                //this.state.templateItem.map((value, index, arr) =>
                  //this._renderAnswer(value, index, arr)
                //)
              }
            </DialogContent>
          )
        }

        <div style={{margin:'10px'}}>
          {
            this.state.templateItem.map((value, index, arr) =>
              this._renderButton(value, index, arr)
            )
          }
        </div>
			</Dialog>
		)
	}
}


export default Comp;
